import React from 'react'
import { observer } from 'mobx-react-lite'
import { Button, Popover, Space } from 'antd'
import type { DeliveryItem } from '@/domains/hooks/useDelivery'
import UserIcon from '@/components/UserIcon/UserIcon'

type Props = {
  userList: DeliveryItem['userList']
}

function ParticipantTags(props: Props): JSX.Element {
  const { userList } = props

  if (!userList?.length) {
    return null
  }

  return (
    <div
      className="delivery-participant-avatars flex items-center justify-end"
      onClick={(e) => e.stopPropagation()}
    >
      <Space size={0}>
        {userList.slice(0, 5).map((userItem, index) => (
          <UserIcon
            key={userItem.userId}
            id={userItem.userId}
            effect={index === 0 ? 'leader' : null}
          />
        ))}
        {userList.length > 5 && (
          <Popover
            content={
              <ul className="delivery-participant-popover-list">
                {userList.map((userItem, index) => (
                  <li key={userItem.userId} className="flex items-center">
                    <UserIcon
                      id={userItem.userId}
                      effect={index === 0 ? 'leader' : null}
                    />
                  </li>
                ))}
              </ul>
            }
          >
            <Button type="text">查看全部({userList.length})</Button>
          </Popover>
        )}
      </Space>
    </div>
  )
}

export default observer(ParticipantTags)
